/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import MapboxDraw, {DrawCustomMode, DrawCustomModeThis, MapMouseEvent} from "@mapbox/mapbox-gl-draw";

export const StaticMode: DrawCustomMode = {
    onSetup() {
        (this as DrawCustomModeThis).setActionableState({
            trash: false,
            combineFeatures: false,
            uncombineFeatures: false,
        });
        return {};
    },

    toDisplayFeatures(_state, geojson, display) {
        display(geojson);
    },
};
export const RemoveVertexMode = (
    mapboxDraw: MapboxDraw,
    DirectSelect: DrawCustomMode,
    onModeChange: (mode: string) => void,
) => {
    const original = {...DirectSelect};
    const Constants = MapboxDraw.constants;
    original.onDrag = function () {
        //no op
    };
    original.onMouseMove = function (_state: any, e: MapMouseEvent) {
        const onVertex = MapboxDraw.lib.CommonSelectors.isOfMetaType(Constants.meta.VERTEX)(e);
        this.updateUIClasses({mouse: Constants.cursors.DRAG});
        if (onVertex) {
            this.updateUIClasses({mouse: Constants.cursors.MOVE});
        }
    };

    // Another way to change cursor.
    //     onMouseMove: function(state, e) {
    //         const features = this.featuresAt(e);
    //         this.map.getCanvas().style.cursor = features.length ? "crosshair" : "inherit";
    //     },

    original.onClick = function (state: any, e: MapMouseEvent) {
        const onVertex = MapboxDraw.lib.CommonSelectors.isOfMetaType(Constants.meta.VERTEX)(e);
        //We ignore clicks, if they are not on vertex
        if (!onVertex) {
            return;
        }
        let feature;
        if (state.feature.type === "Polygon") {
            feature = state.feature;
        } else if (state.feature.type === "MultiPolygon") {
            feature = state.feature.features[0];
        } else {
            return;
        }
        if (state.selectedCoordPaths.length) {
            // Get the clicked vertex index and ring
            const coordPath = state.selectedCoordPaths[0];
            const coords = coordPath.split(".");
            let ringIndex = parseInt(coords[0], 10);
            let vertexIndex = parseInt(coords[1], 10);

            if (state.feature.type === "MultiPolygon") {
                ringIndex = parseInt(coords[1], 10);
                vertexIndex = parseInt(coords[2], 10);
            }

            // Remove the vertex from the polygon
            feature.removeCoordinate(`${ringIndex}.${vertexIndex}`);
            this.clearSelectedCoordinates();
            // If after removing the point, the ring has fewer than 3 vertices, it's not a valid polygon ring
            if (feature.coordinates.length === 0 || feature.coordinates[ringIndex].length < 3) {
                feature.removeCoordinate(`${ringIndex}`);
                this.deleteFeature(state.featureId);
                mapboxDraw.deleteAll();
                onModeChange(Constants.modes.STATIC);
            } else {
                feature.changed();
                //Call to trigger the onupdate handler.
                //@ts-expect-error, this is an internal function and not a part of public API.
                this.fireUpdate();
            }
        }
    };
    return original;
};
